<template>
    <div>
        <loading-gdb :propObject="StateDevicesLoading" text="Carregando Dispositivos" />
        <v-btn-small color="info" title="Atualizar" @click="GetDevices">
            <v-icon>mdi-refresh</v-icon> Atualizar
        </v-btn-small>
        <v-text-field class="mt-4" v-model="search"
            label="Pesquisar dispositivo..."
            hide-details
            variant="outlined"
            >
        </v-text-field>
        <div v-if="(computedDevices||[]).length > 0" class="mt-1">
            <v-card tile v-for="device in computedDevices" :key="device.id" variant="outlined" class="my-1">
                <v-card-title>
                    <h4>{{device.name}}</h4>
                </v-card-title>
                <v-card-text>
                    <div class="ma-1">
                        <v-chip color="info" label title="IP do Equipamento">{{device.host}}</v-chip>
                    </div>
                    <div>
                        <v-btn-small title="Acessar equipamento remotamente"
                            :href="device.URL+':'+device.port" target="_blank">
                            <v-icon>mdi-web</v-icon>
                        </v-btn-small>
                        <v-btn-small label title="Beep">
                            <v-icon :color="device.beep ? 'success' : 'error'">mdi-bullhorn</v-icon>
                        </v-btn-small>
                        <v-btn-small label title="Anti pass back">
                            <v-icon :color="device.antiPassback ? 'success' : 'error'">
                                {{device.antiPassback ? 'mdi-check' : 'mdi-close'}}
                            </v-icon>
                        </v-btn-small>
                        <v-btn-small label title="Quantidade de Reset">
                            {{device.ResetCount}}
                        </v-btn-small>
                        <v-btn-small label title="Versão Firmware">
                            {{device.versao}}
                        </v-btn-small>
                    </div>
                    <div>
                        <v-btn-small label title="Modelo de Equipamento">
                            {{device.DeviceModel}}
                        </v-btn-small>
                        <v-btn-small label title="Serial">
                            {{device.serial}}
                        </v-btn-small>
                    </div>
                    <br>
                    <v-btn-small color="primary" @click.stop="GetDeviceChild({id:device.id})">
                        <v-icon>mdi-refresh</v-icon>   {{(device.child||[]).length ? 'Atualizar' : 'Carregar Equipamentos'}}
                    </v-btn-small>
                    <div class="my-2">
                        <v-row>
                            <v-col cols="12" sm="6" v-for="child in device.child" :key="child.id">
                                <div>
                                    <v-img :src="'data:image/png;base64, '+child.logo" max-width="40" class="mr-3"></v-img>
                                    <b>#{{child.id}}</b>
                                    <div>{{child.name}}</div>
                                    <div>
                                        <div class="ma-1">
                                            <v-btn-small label
                                                title="Acessar equipamento remotamente"
                                                :href="child.URL+':'+child.port" target="_blank">
                                                <v-icon>mdi-web</v-icon>
                                            </v-btn-small>
                                            <v-btn-small label title="Versão">
                                                <v-icon title="Status do Equipamento"
                                                    :color="child.isCurrentlyOnline ? 'success' : 'error'">
                                                    {{child.isCurrentlyOnline ? 'mdi-check' : 'mdi-alert-circle'}}
                                                </v-icon>
                                            </v-btn-small>
                                            <v-btn-small label title="Versão">{{child.versao}}</v-btn-small>
                                            <v-btn-small label title="Intensidade de LED">{{child.ledIntensity}}%</v-btn-small>
                                            <v-btn-small label title="Quantidade de Reset">{{child.ResetCount}}</v-btn-small>
                                            <v-btn-small label title="Distância de identificação">{{child.identificationDistance}}cm</v-btn-small>
                                            <v-btn-small label title="Anti pass back">
                                                <v-icon :color="child.antiPassback ? 'success' : 'error'">
                                                    {{child.antiPassback ? 'mdi-check' : 'mdi-close'}}
                                                </v-icon>
                                            </v-btn-small>
                                            <v-btn-small label title="Reset diariamente">
                                                <v-icon :color="child.dailyReset ? 'success' : 'error'">
                                                    {{child.dailyReset ? 'mdi-check' : 'mdi-close'}}
                                                </v-icon>
                                            </v-btn-small>
                                            <v-btn-small label title="Beep">
                                                <v-icon :color="child.beep ? 'success' : 'error'">mdi-bullhorn</v-icon>
                                            </v-btn-small>
                                            <v-btn-small label title="Detecção de máscara">
                                                <v-icon :color="child.maskDetectionEnabled ? 'success' : 'error'">mdi-face-mask</v-icon>
                                            </v-btn-small>
                                        </div>
                                        <div>
                                            <v-btn-small label title="Modelo de Equipamento">{{child.DeviceModel}}</v-btn-small>
                                            <v-btn-small label title="Serial">{{child.serial}}</v-btn-small>
                                            <v-btn-small title="IP do Equipamento" color="info">{{child.host}}</v-btn-small>
                                            <v-btn-small title="Testar" color="success" @click="TestConnect(child)">Testar</v-btn-small>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'IDSecureDevices',
    mounted(){
        this.GetDevices()
        setTimeout(()=>{
            if (this.StateDevices && this.StateDevices.data){
                // Para cada Catraca, carregar seus child
                this.StateDevices.data.forEach(element => {
                    element
                    //this.GetDeviceChild({id:element.id})
                });
            }
        }, 2000)
    },
    data: ()=>({
        search: ''
    }),
    methods:{
        ...mapActions(['GetDevices','GetDeviceChild', 'TestConnect']),
        spin_giro(value) {
            switch(value){
                case "blocked": return "Ambas controladas";
                case "entrance_open": return "Entrada liberada e Saída controlada";
                case "exit_open": return "Entrada controlada e Saída liberada";
                case "both_open": return "Ambas liberadas";
                case "exit_locked": return "Entrada controlada e Saída bloqueada";
                case "entrance_locked": return "Entrada bloqueada e Saída controlada";
                default: value
            }
        }
    },
    computed:{
        ...mapGetters(['StateDevices','StateDevicesLoading']),
        computedDevices(){
            var devices = this.StateDevices.data
            if (this.search.length > 0){
                devices = devices.filter(i => {
                    const filtro_name = i.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ;
                    const filtro_url = i.URL.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ;
                    const filtro_device_model = i.DeviceModel.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ;
                    const serial = i.serial.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ;
                    const versao = i.versao.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
                    return filtro_name || filtro_url || filtro_device_model || serial || versao
                }
                )
            }
            return devices
        }
    },
}
</script>